import React from 'react';
import { useSelector } from "react-redux";
import { Button } from "@material-ui/core";
import { validarQueTengaAunqueSeaUnSoloPermiso, validarSoloUnPermiso } from '../helpers/permisos';

export const BreadcrumbsItemsCustom = ({buttons, handleClick}) => {
    const { permisos: permisosUser } = useSelector(state => state.auth)

    const enabledButtons = buttons.filter( 
        i => (!i.permiso && !i.validarAlgunPermiso) 
            || validarSoloUnPermiso(permisosUser, i.permiso) 
            || validarQueTengaAunqueSeaUnSoloPermiso(permisosUser, [i.validarAlgunPermiso]));

    return ( 
        <>
            {
                enabledButtons.map((item, index) =>
                <React.Fragment key={index}>
                    {index > 0 && index < enabledButtons.length &&
                        <span aria-hidden="true">{` / `}</span>
                    }
                    <Button
                        color={item.color}
                        name={item.name}
                        onClick={(e) => handleClick(e)}
                    >
                        <item.icon className={item.classIcon} />
                        {item.text}
                    </Button>
                </React.Fragment>
            )}
       </>
     );
}